/**
 * @generated SignedSource<<36dbb111f324b7498c6646f5fc53898b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type designTemplatesQueriesDeleteTemplatesMutation$variables = {
  modelId: number;
  templateIds: ReadonlyArray<number>;
};
export type designTemplatesQueriesDeleteTemplatesMutation$data = {
  readonly deleteTemplates: ReadonlyArray<{
    readonly colors: ReadonlyArray<{
      readonly colorID: number;
      readonly isDefault: boolean;
      readonly name: string | null;
    } | null>;
    readonly designTemplateId: number;
    readonly id: string;
    readonly name: string;
    readonly previewUrl: string;
  }>;
};
export type designTemplatesQueriesDeleteTemplatesMutation = {
  response: designTemplatesQueriesDeleteTemplatesMutation$data;
  variables: designTemplatesQueriesDeleteTemplatesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelId",
        "variableName": "modelId"
      },
      {
        "kind": "Variable",
        "name": "templateIds",
        "variableName": "templateIds"
      }
    ],
    "concreteType": "DesignTemplate",
    "kind": "LinkedField",
    "name": "deleteTemplates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "designTemplateId",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previewUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignTemplateColor",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "designTemplatesQueriesDeleteTemplatesMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "designTemplatesQueriesDeleteTemplatesMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "a3c75876ea332dcda104ac27f5f6b781",
    "id": null,
    "metadata": {},
    "name": "designTemplatesQueriesDeleteTemplatesMutation",
    "operationKind": "mutation",
    "text": "mutation designTemplatesQueriesDeleteTemplatesMutation(\n  $modelId: Long!\n  $templateIds: [Long!]!\n) {\n  deleteTemplates(modelId: $modelId, templateIds: $templateIds) {\n    id\n    designTemplateId\n    name\n    previewUrl\n    colors {\n      colorID\n      name\n      isDefault\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a9ea3e19b481128e6997edd7dce4e38d";

export default node;
